import React from 'react'

function formatCurrency(value) {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD',
  }).format(Number(value ?? 0))
}

export default function MenuPricingBreakdown({ pricing, loading }) {
  if (loading) {
    return <p className="luxury-menu__pricing-loading">Calculating totals…</p>
  }

  if (!pricing) return null

  return (
    <div className="luxury-menu__pricing-breakdown">
      <div className="luxury-menu__pricing-row">
        <span>Subtotal</span>
        <span>{formatCurrency(pricing.subtotal)}</span>
      </div>
      {pricing.taxAmount > 0 && (
        <div className="luxury-menu__pricing-row">
          <span>Tax</span>
          <span>{formatCurrency(pricing.taxAmount)}</span>
        </div>
      )}
      {pricing.providerCharge > 0 && (
        <div className="luxury-menu__pricing-row">
          <span>
            Provider fee
            {pricing.providerChargeRate
              ? ` (${pricing.providerChargeRate}%)`
              : ''}
          </span>
          <span>{formatCurrency(pricing.providerCharge)}</span>
        </div>
      )}
      {pricing.processingFee > 0 && (
        <div className="luxury-menu__pricing-row">
          <span>Processing fee</span>
          <span>{formatCurrency(pricing.processingFee)}</span>
        </div>
      )}
      <div className="luxury-menu__pricing-row luxury-menu__pricing-row--total">
        <span>Total</span>
        <span>{formatCurrency(pricing.total)}</span>
      </div>
    </div>
  )
}
